
import { Component, Vue, Prop, Watch, Emit, Ref, Model } from 'vue-property-decorator'
import type { ConfirmModalOptions } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Cascader } from 'ant-design-vue'
import ConfirmModal from '../ConfirmModal/index.vue'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import { type CascaderNode } from '@xt/client/dataSource/china/index'

@Observer
@Component({
  components: {
    Cascader,
    ConfirmModal
  }
})
export default class extends Vue {
  selectValue: string | null = null
  options: ConfirmModalOptions = {
    title: '发起分桐',
    description: '发起成功后将自动加入该城市分桐，我们会选取热力值最高的1-2个城市，优先推动分桐开放。',
    layoutClassName: 'init-confirm-modal',
    confirmedHide: true,
    confirmText: '立即创建',
    cancelText: '稍后再说',
    backgroundUrl: this.$store.$global.static + '/images/topic/pc/init-pop-bg.png',
    onOk: () => {
      this.$msg('敬请期待~')
    }
  }
  isOpen: boolean = false
  cascadeOptions: Array<CascaderNode> = []

  @Ref()
  confirmModal: {
    show: (options: ConfirmModalOptions) => void
    hide: () => void
  }

  get CityStore() {
    return this.$store.$tonghao.Cities
  }

  @Emit('select')
  handleChange(value, selectedOptions: CascaderNode) {
    return value
  }

  onOpenChange(open: boolean) {
    this.isOpen = open
  }

  show(options: ConfirmModalOptions = {}) {
    this.confirmModal.show(lodash.merge(this.options, options))
  }

  hide() {
    this.confirmModal.hide()
  }

  onClosed() {
    this.selectValue = null
    this.isOpen = false
  }

  async initCascaderData() {
    const res = await this.CityStore.loadCascadeCities()

    if (!res) return

    this.cascadeOptions = res
  }

  created(): void {
    this.initCascaderData()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
